/**
 * Registers the caller's New Relic key with the backend.
 * - In real mode: POSTs JSON body { key } with Bearer token; expects 204.
 * - In mock mode: performs no network I/O and simulates success.
 */
const IS_MOCK_MODE = process.env.REACT_APP_AUTH_MODE !== "ms_entra_id"; // per project convention
const BASE = String(process.env.REACT_APP_SPRING_BOOT_API_URL || "").replace(/\/+$/, "");

export async function registerNewRelicKey(opts: {
    key: string;
    accessToken?: string; // required when not in mock mode
}): Promise<void> {
    const { key, accessToken } = opts;

    if (IS_MOCK_MODE) {
        // Simulate latency without persisting or transmitting the key.
        await new Promise((r) => setTimeout(r, 250));
        return;
    }

    if (!accessToken) {
        throw new Error("Missing access token");
    }

    const res = await fetch(`${BASE}/api/integrations/newrelic/token`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`,
        },
        // Do not include userId; server associates by MSAL OID.
        body: JSON.stringify({ key }),
        cache: "no-store",
    });

    // Treat 204 as success; some stacks may also return 200 with empty body.
    if (!(res.status === 204 || res.ok)) {
        let msg = `Failed to register key (HTTP ${res.status})`;
        try {
            const data = await res.json();
            if (data?.message) msg = data.message;
        } catch {}
        throw new Error(msg);
    }
}
